import React, { useEffect, useState } from 'react'
import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'
import './menuActivity.scss'
import { graphql, Link, navigate, useStaticQuery } from 'gatsby'
import { ageAdult } from '../../../constants/activity-constants'

const MenuActivity = ({ active }) => {

  const isMobile = useMediaQuery()
  const [isActiveMenu, setIsActiveMenu] = useState(false)
  const [isShowMenu, setIsShowMenu] = useState(false)
  const [showMobile, setShowMobile] = useState(active ? true : false)
  const [isLog, setIsLog] = useState(false)
  const [userName, setUserName] = useState('')
  const user = new userSessionStorage()

  const optionsMenu = [
    {
      label: (
        <>
          Ini<span>c</span>io
        </>
      ),
      href: '/',
      singleLabel: 'Inicio',
    },
    {
      label: (
        <>
          A<span>c</span>
          <span>t</span>ivi<span>d</span>
          <span>a</span>des
        </>
      ),
      href: '/actividades',
      singleLabel: 'Actividades',

    },
    {
      label: (
        <>
          C<span>o</span>mu<span>n</span>
          <span>i</span>dad
        </>
      ),
      href: '/comunidad',
      singleLabel: 'Comunidad',

    },
    {
      label: (
        <>
          Pr<span>o</span>g<span>r</span>
          <span>e</span>so
        </>
      ),
      href: '/progreso',
      singleLabel: 'Progreso',

    },

    {
      label: (
        <>
          Apr<span>e</span>nd<span>e</span>
        </>
      ),
      href: '/aprende',
      singleLabel: 'Aprende',

    },
  ]

  const handleIsActiveMenu = () => {
    setIsShowMenu(!isShowMenu)
    if (isActiveMenu) {
      setTimeout(() => {
        setIsActiveMenu(!isActiveMenu)
      }, 500)
    } else {
      setIsActiveMenu(!isActiveMenu)
    }
  }

  const handleCloseSession = () => {
    user.destroySession()
    let path = window.location.pathname.split('/')
    if (path[path.length - 1] === '') path.pop()
    if (path[path.length - 1] === '') {
      window.location.reload()
    } else {
      let host = path[path.length - 1]
      if (host === 'vive-el-cole') {
        window.location.reload()
      } else {
        navigate('/')
      }
    }
  }

  useEffect(() => {
    if (active || showMobile) {
      setShowMobile(true)
      handleIsActiveMenu()
    }
  }, [active])

  useEffect(() => {
    if (localStorage.getItem('TOKEN_INFO')) {
      setIsLog(true)
      setUserName(
        JSON.parse(localStorage.getItem('USER_INFO')).name.split(' ')[0],
      )
    }
  }, [])

  const [adult, setAdult] = useState(false)

  useEffect(() => {
    let ageUser = JSON.parse(localStorage.getItem('USER_INFO')).birthdate.split(
      '-',
    )[0]
    const presentYear = new Date().getFullYear()

    let isAdult = parseInt(ageUser) <= presentYear - ageAdult()
    setAdult(isAdult)
  }, [])

  return (
    <>
      {!isMobile && (
        <>
          <div
            className={`f-menu-activity__btn ${isShowMenu ? 'active' : ''}`}
            onClick={() => {
              handleIsActiveMenu()
            }}
          ></div>
          {isLog && (
            <div className='f-menu-activity__message'>
              <span>
                Hola,{' '}
                {JSON.parse(localStorage.getItem('USER_INFO')) && adult
                  ? 'Bienvenid@s'
                  : userName}
              </span>
              <button onClick={() => handleCloseSession()}>
                Cerrar sesión
              </button>
            </div>
          )}
        </>
      )}
      {isActiveMenu && (
        <div className={`f-menu-activity__menu ${isShowMenu ? 'active' : ''}`}>
          <nav
            className={`f-menu-activity__menu__nav ${
              isShowMenu ? 'active' : ''
            }`}
          >
            {optionsMenu.map((option, index) => {
              return (
                <Link
                  to={option.href}
                  className='menu'
                  activeClassName={`menu-active item-${index + 1}`}
                  key={index}
                  onClick={() => {
                    try {
                      window.dataLayer.push({
                        event: 'ga_event',
                        category: 'Vive el Cole :: Menu',
                        action: 'Click',
                        label: option.singleLabel,
                        value: '',
                      })
                    } catch (error) {
                      console.log('Datalayer error:', error)
                    }
                  }}
                >
                  {option.label}
                </Link>
              )
            })}
            {isLog && isMobile && (
              <div className='f-menu-activity__menu__nav__user'>
                <p>
                  Nombre de usuario <b> {userName}</b>
                </p>{' '}
                <button onClick={() => handleCloseSession()}>
                  Cerrar sesión
                </button>
              </div>
            )}
          </nav>
        </div>
      )}
    </>
  )
}

export default MenuActivity
